export default __webpack_public_path__ + "static/media/vivabonito2.91b9a013.jpg";